J = jQuery.noConflict();

        const lifeStageOptions = {
            'lS0': 'Broodmare',
            'lS1': 'Mature',
            'lS2': 'Weanling',
            'lS3': 'Yearling'
        }

        const productTypeOptions = {
            'pT0': 'Full Concentrates',
            'pT1': 'Ration Balancers'
        }

        const ageStatusOptions = {
            'lS0_pT0': ['Open Mare', 'Pregnant Mare', 'Nursing Mare: First 3 Months', 'Nursing Mare: Second 3 Months'],
            'lS0_pT1': ['Open Mare', 'Pregnant Mare', 'Nursing Mare: First 3 Months', 'Nursing Mare: Second 3 Months'],
            'lS1_pT0': ['Idle', 'Light', 'Moderate', 'Heavy'],
            'lS1_pT1': ['Idle', 'Light', 'Moderate'],
            'lS2_pT0': ['3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
            'lS2_pT1': ['3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
            'lS3_pT0': ['13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24'],
            'lS3_pT1': ['13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23']
        }

        const weightOptions = {
            'lS0_pT0_aSOM' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb', '1400 lb', '1500 lb', '1600 lb', '1700 lb', '1800 lb', '1900 lb', '2000 lb'],
            'lS0_pT1_aSOM' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb', '1400 lb', '1500 lb', '1600 lb', '1700 lb', '1800 lb', '1900 lb', '2000 lb'],
            'lS0_pT0_aSPM' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb', '1400 lb', '1500 lb', '1600 lb', '1700 lb', '1800 lb', '1900 lb', '2000 lb'],
            'lS0_pT1_aSPM' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb', '1400 lb', '1500 lb', '1600 lb', '1700 lb', '1800 lb', '1900 lb', '2000 lb'],
            'lS0_pT0_aSNMF3M' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb', '1400 lb', '1500 lb', '1600 lb', '1700 lb', '1800 lb', '1900 lb', '2000 lb'],
            'lS0_pT1_aSNMF3M' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb', '1400 lb', '1500 lb', '1600 lb', '1700 lb', '1800 lb', '1900 lb', '2000 lb'],
            'lS0_pT0_aSNMS3M' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb', '1400 lb', '1500 lb', '1600 lb', '1700 lb', '1800 lb', '1900 lb', '2000 lb'],
            'lS0_pT1_aSNMS3M' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb', '1400 lb', '1500 lb', '1600 lb', '1700 lb', '1800 lb', '1900 lb', '2000 lb'],
            'lS1_pT0_aSI' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb', '1400 lb', '1500 lb', '1600 lb', '1700 lb', '1800 lb', '1900 lb', '2000 lb'],
            'lS1_pT1_aSI' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb', '1400 lb', '1500 lb', '1600 lb', '1700 lb', '1800 lb', '1900 lb', '2000 lb'],
            'lS1_pT0_aSL' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb', '1400 lb', '1500 lb', '1600 lb', '1700 lb', '1800 lb', '1900 lb', '2000 lb'],
            'lS1_pT1_aSL' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb', '1400 lb', '1500 lb', '1600 lb', '1700 lb', '1800 lb', '1900 lb', '2000 lb'],
            'lS1_pT0_aSM' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb', '1400 lb', '1500 lb', '1600 lb', '1700 lb', '1800 lb', '1900 lb', '2000 lb'],
            'lS1_pT1_aSM' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb', '1400 lb', '1500 lb', '1600 lb', '1700 lb', '1800 lb', '1900 lb', '2000 lb'],
            'lS1_pT0_aSH' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb', '1400 lb', '1500 lb', '1600 lb', '1700 lb', '1800 lb', '1900 lb', '2000 lb'],
            'lS2_pT0_aS3' : ['<100 lb', '100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb'],
            'lS2_pT1_aS3' : ['<100 lb', '100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb'],
            'lS2_pT0_aS4' : ['<100 lb', '100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb'],
            'lS2_pT1_aS4' : ['<100 lb', '100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb'],
            'lS2_pT0_aS5' : ['<100 lb', '100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb'],
            'lS2_pT1_aS5' : ['<100 lb', '100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb'],
            'lS2_pT0_aS6' : ['<100 lb', '100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb'],
            'lS2_pT1_aS6' : ['<100 lb', '100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb'],
            'lS2_pT0_aS7' : ['<100 lb', '100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb'],
            'lS2_pT1_aS7' : ['<100 lb', '100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb'],
            'lS2_pT0_aS8' : ['<100 lb', '100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb'],
            'lS2_pT1_aS8' : ['<100 lb', '100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb'],
            'lS2_pT0_aS9' : ['<100 lb', '100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb'],
            'lS2_pT1_aS9' : ['<100 lb', '100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb'],
            'lS2_pT0_aS10' : ['<100 lb', '100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb'],
            'lS2_pT1_aS10' : ['<100 lb', '100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb'],
            'lS2_pT0_aS11' : ['<100 lb', '100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb'],
            'lS2_pT1_aS11' : ['<100 lb', '100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb'],
            'lS2_pT0_aS12' : ['<100 lb', '100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb'],
            'lS2_pT1_aS12' : ['<100 lb', '100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb'],
            'lS3_pT0_aS13' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb'],
            'lS3_pT1_aS13' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb'],
            'lS3_pT0_aS14' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb'],
            'lS3_pT1_aS14' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb'],
            'lS3_pT0_aS15' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb'],
            'lS3_pT1_aS15' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb'],
            'lS3_pT0_aS16' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb', '1400 lb'],
            'lS3_pT1_aS16' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb', '1400 lb'],
            'lS3_pT0_aS17' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb', '1400 lb'],
            'lS3_pT1_aS17' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb', '1400 lb'],
            'lS3_pT0_aS18' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb', '1400 lb', '1500 lb'],
            'lS3_pT1_aS18' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb', '1400 lb', '1500 lb'],
            'lS3_pT0_aS19' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb', '1400 lb', '1500 lb'],
            'lS3_pT1_aS19' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb', '1400 lb', '1500 lb'],
            'lS3_pT0_aS20' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb', '1400 lb', '1500 lb', '1600 lb'],
            'lS3_pT1_aS20' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb', '1400 lb', '1500 lb', '1600 lb'],
            'lS3_pT0_aS21' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb', '1400 lb', '1500 lb', '1600 lb'],
            'lS3_pT1_aS21' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb', '1400 lb', '1500 lb', '1600 lb'],
            'lS3_pT0_aS22' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb', '1400 lb', '1500 lb', '1600 lb', '1700 lb'],
            'lS3_pT1_aS22' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb', '1400 lb', '1500 lb', '1600 lb', '1700 lb'],
            'lS3_pT0_aS23' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb', '1400 lb', '1500 lb', '1600 lb', '1700 lb'],
            'lS3_pT1_aS23' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb', '1400 lb', '1500 lb', '1600 lb', '1700 lb'],
            'lS3_pT0_aS24' : ['100 lb', '200 lb', '300 lb', '400 lb', '500 lb', '600 lb', '700 lb', '800 lb', '900 lb', '1000 lb', '1100 lb', '1200 lb', '1300 lb', '1400 lb', '1500 lb', '1600 lb', '1700 lb', '1800 lb', '1900 lb', '2000 lb']
        }

        const results = {
            'lS2_pT1_aS3_w0': '0.75 - 1.00',
            'lS2_pT1_aS4_w0': '0.75 - 1.00',
            'lS2_pT1_aS5_w0': '0.75 - 1.00',
            'lS2_pT1_aS6_w0': '0.75 - 1.00',
            'lS2_pT1_aS7_w0': '0.75 - 1.00',
            'lS2_pT1_aS8_w0': '0.75 - 1.00',
            'lS2_pT1_aS9_w0': '0.75 - 1.00',
            'lS2_pT1_aS10_w0': '0.75 - 1.00',
            'lS2_pT1_aS11_w0': '0.75 - 1.00',
            'lS2_pT1_aS12_w0': '0.75 - 1.00',
            'lS2_pT1_aS3_w100': '1.25 - 1.50',
            'lS2_pT1_aS4_w100': '1.25 - 1.50',
            'lS2_pT1_aS5_w100': '1.25 - 1.50',
            'lS2_pT1_aS6_w100': '1.25 - 1.50',
            'lS2_pT1_aS7_w100': '1.25 - 1.50',
            'lS2_pT1_aS8_w100': '1.25 - 1.50',
            'lS2_pT1_aS9_w100': '1.25 - 1.50',
            'lS2_pT1_aS10_w100': '1.25 - 1.50',
            'lS2_pT1_aS11_w100': '1.25 - 1.50',
            'lS2_pT1_aS12_w100': '1.25 - 1.50',
            'lS2_pT1_aS3_w200': '1.50 - 1.75',
            'lS2_pT1_aS4_w200': '1.50 - 1.75',
            'lS2_pT1_aS5_w200': '1.50 - 1.75',
            'lS2_pT1_aS6_w200': '1.50 - 1.75',
            'lS2_pT1_aS7_w200': '1.50 - 1.75',
            'lS2_pT1_aS8_w200': '1.50 - 1.75',
            'lS2_pT1_aS9_w200': '1.50 - 1.75',
            'lS2_pT1_aS10_w200': '1.50 - 1.75',
            'lS2_pT1_aS11_w200': '1.50 - 1.75',
            'lS2_pT1_aS12_w200': '1.50 - 1.75',
            'lS2_pT1_aS3_w300': '2.00 - 2.25',
            'lS2_pT1_aS4_w300': '2.00 - 2.25',
            'lS2_pT1_aS5_w300': '2.00 - 2.25',
            'lS2_pT1_aS6_w300': '2.00 - 2.25',
            'lS2_pT1_aS7_w300': '2.00 - 2.25',
            'lS2_pT1_aS8_w300': '2.00 - 2.25',
            'lS2_pT1_aS9_w300': '2.00 - 2.25',
            'lS2_pT1_aS10_w300': '2.00 - 2.25',
            'lS2_pT1_aS11_w300': '2.00 - 2.25',
            'lS2_pT1_aS12_w300': '2.00 - 2.25',
            'lS2_pT1_aS3_w400': '2.50 - 3.00',
            'lS2_pT1_aS4_w400': '2.50 - 3.00',
            'lS2_pT1_aS5_w400': '2.50 - 3.00',
            'lS2_pT1_aS6_w400': '2.50 - 3.00',
            'lS2_pT1_aS7_w400': '2.50 - 3.00',
            'lS2_pT1_aS8_w400': '2.50 - 3.00',
            'lS2_pT1_aS9_w400': '2.50 - 3.00',
            'lS2_pT1_aS10_w400': '2.50 - 3.00',
            'lS2_pT1_aS11_w400': '2.50 - 3.00',
            'lS2_pT1_aS12_w400': '2.50 - 3.00',
            'lS2_pT1_aS3_w500': '3.00 - 3.50',
            'lS2_pT1_aS4_w500': '3.00 - 3.50',
            'lS2_pT1_aS5_w500': '3.00 - 3.50',
            'lS2_pT1_aS6_w500': '3.00 - 3.50',
            'lS2_pT1_aS7_w500': '3.00 - 3.50',
            'lS2_pT1_aS8_w500': '3.00 - 3.50',
            'lS2_pT1_aS9_w500': '3.00 - 3.50',
            'lS2_pT1_aS10_w500': '3.00 - 3.50',
            'lS2_pT1_aS11_w500': '3.00 - 3.50',
            'lS2_pT1_aS12_w500': '3.00 - 3.50',
            'lS2_pT1_aS3_w600': '3.00 - 4.00',
            'lS2_pT1_aS4_w600': '3.00 - 4.00',
            'lS2_pT1_aS5_w600': '3.00 - 4.00',
            'lS2_pT1_aS6_w600': '3.00 - 4.00',
            'lS2_pT1_aS7_w600': '3.00 - 4.00',
            'lS2_pT1_aS8_w600': '3.00 - 4.00',
            'lS2_pT1_aS9_w600': '3.00 - 4.00',
            'lS2_pT1_aS10_w600': '3.00 - 4.00',
            'lS2_pT1_aS11_w600': '3.00 - 4.00',
            'lS2_pT1_aS12_w600': '3.00 - 4.00',
            'lS2_pT1_aS4_w700': '3.00 - 4.00',
            'lS2_pT1_aS5_w700': '3.00 - 4.00',
            'lS2_pT1_aS6_w700': '3.00 - 4.00',
            'lS2_pT1_aS7_w700': '3.00 - 4.00',
            'lS2_pT1_aS8_w700': '3.00 - 4.00',
            'lS2_pT1_aS9_w700': '3.00 - 4.00',
            'lS2_pT1_aS10_w700': '3.00 - 4.00',
            'lS2_pT1_aS11_w700': '3.00 - 4.00',
            'lS2_pT1_aS12_w700': '3.00 - 4.00',
            'lS2_pT1_aS5_w800': '3.00 - 4.00',
            'lS2_pT1_aS6_w800': '3.00 - 4.00',
            'lS2_pT1_aS7_w800': '3.00 - 4.00',
            'lS2_pT1_aS8_w800': '3.00 - 4.00',
            'lS2_pT1_aS9_w800': '3.00 - 4.00',
            'lS2_pT1_aS10_w800': '3.00 - 4.00',
            'lS2_pT1_aS11_w800': '3.00 - 4.00',
            'lS2_pT1_aS12_w800': '3.00 - 4.00',
            'lS2_pT1_aS6_w900': '3.00 - 4.00',
            'lS2_pT1_aS7_w900': '3.00 - 4.00',
            'lS2_pT1_aS8_w900': '3.00 - 4.00',
            'lS2_pT1_aS9_w900': '3.00 - 4.00',
            'lS2_pT1_aS10_w900': '3.00 - 4.00',
            'lS2_pT1_aS11_w900': '3.00 - 4.00',
            'lS2_pT1_aS12_w900': '3.00 - 4.00',
            'lS2_pT1_aS7_w1000': '4.00 - 5.00',
            'lS2_pT1_aS8_w1000': '4.00 - 5.00',
            'lS2_pT1_aS9_w1000': '4.00 - 5.00',
            'lS2_pT1_aS10_w1000': '4.00 - 5.00',
            'lS2_pT1_aS11_w1000': '4.00 - 5.00',
            'lS2_pT1_aS12_w1000': '4.00 - 5.00',
            'lS3_pT1_aS13_w100': '1.00 -  1.25',
            'lS3_pT1_aS14_w100': '1.00 -  1.25',
            'lS3_pT1_aS15_w100': '1.00 -  1.25',
            'lS3_pT1_aS16_w100': '1.00 -  1.25',
            'lS3_pT1_aS17_w100': '1.00 -  1.25',
            'lS3_pT1_aS18_w100': '1.00 -  1.25',
            'lS3_pT1_aS19_w100': '1.00 -  1.25',
            'lS3_pT1_aS20_w100': '0.50 -0.75',
            'lS3_pT1_aS21_w100': '0.50 -0.75',
            'lS3_pT1_aS22_w100': '0.50 -0.75',
            'lS3_pT1_aS23_w100': '0.50 -0.75',
            'lS3_pT1_aS13_w200': '1.00 -  1.25',
            'lS3_pT1_aS14_w200': '1.00 -  1.25',
            'lS3_pT1_aS15_w200': '1.00 -  1.25',
            'lS3_pT1_aS16_w200': '1.00 -  1.25',
            'lS3_pT1_aS17_w200': '1.00 -  1.25',
            'lS3_pT1_aS18_w200': '1.00 -  1.25',
            'lS3_pT1_aS19_w200': '1.00 -  1.25',
            'lS3_pT1_aS20_w200': '0.50 -0.75',
            'lS3_pT1_aS21_w200': '0.50 -0.75',
            'lS3_pT1_aS22_w200': '0.50 -0.75',
            'lS3_pT1_aS23_w200': '0.50 -0.75',
            'lS3_pT1_aS13_w300': '1.50 - 1.75',
            'lS3_pT1_aS14_w300': '1.50 - 1.75',
            'lS3_pT1_aS15_w300': '1.50 - 1.75',
            'lS3_pT1_aS16_w300': '1.50 - 1.75',
            'lS3_pT1_aS17_w300': '1.50 - 1.75',
            'lS3_pT1_aS18_w300': '1.50 - 1.75',
            'lS3_pT1_aS19_w300': '1.50 - 1.75',
            'lS3_pT1_aS20_w300': '1.00 - 1.25',
            'lS3_pT1_aS21_w300': '1.00 - 1.25',
            'lS3_pT1_aS22_w300': '1.00 - 1.25',
            'lS3_pT1_aS23_w300': '1.00 - 1.25',
            'lS3_pT1_aS13_w400': '1.50 - 2.00',
            'lS3_pT1_aS14_w400': '1.50 - 2.00',
            'lS3_pT1_aS15_w400': '1.50 - 2.00',
            'lS3_pT1_aS16_w400': '1.50 - 2.00',
            'lS3_pT1_aS17_w400': '1.50 - 2.00',
            'lS3_pT1_aS18_w400': '1.50 - 2.00',
            'lS3_pT1_aS19_w400': '1.50 - 2.00',
            'lS3_pT1_aS20_w400': '1.00 - 1.50',
            'lS3_pT1_aS21_w400': '1.00 - 1.50',
            'lS3_pT1_aS22_w400': '1.00 - 1.50',
            'lS3_pT1_aS23_w400': '1.00 - 1.50',
            'lS3_pT1_aS13_w500': '2.00 - 2.50',
            'lS3_pT1_aS14_w500': '2.00 - 2.50',
            'lS3_pT1_aS15_w500': '2.00 - 2.50',
            'lS3_pT1_aS16_w500': '2.00 - 2.50',
            'lS3_pT1_aS17_w500': '2.00 - 2.50',
            'lS3_pT1_aS18_w500': '2.00 - 2.50',
            'lS3_pT1_aS19_w500': '2.00 - 2.50',
            'lS3_pT1_aS20_w500': '1.50 - 2.00',
            'lS3_pT1_aS21_w500': '1.50 - 2.00',
            'lS3_pT1_aS22_w500': '1.50 - 2.00',
            'lS3_pT1_aS23_w500': '1.50 - 2.00',
            'lS3_pT1_aS13_w600': '2.00 - 3.00',
            'lS3_pT1_aS14_w600': '2.00 - 3.00',
            'lS3_pT1_aS15_w600': '2.00 - 3.00',
            'lS3_pT1_aS16_w600': '2.00 - 3.00',
            'lS3_pT1_aS17_w600': '2.00 - 3.00',
            'lS3_pT1_aS18_w600': '2.00 - 3.00',
            'lS3_pT1_aS19_w600': '2.00 - 3.00',
            'lS3_pT1_aS20_w600': '1.50 - 2.50',
            'lS3_pT1_aS21_w600': '1.50 - 2.50',
            'lS3_pT1_aS22_w600': '1.50 - 2.50',
            'lS3_pT1_aS23_w600': '1.50 - 2.50',
            'lS3_pT1_aS13_w700': '2.50 - 3.50',
            'lS3_pT1_aS14_w700': '2.50 - 3.50',
            'lS3_pT1_aS15_w700': '2.50 - 3.50',
            'lS3_pT1_aS16_w700': '2.50 - 3.50',
            'lS3_pT1_aS17_w700': '2.50 - 3.50',
            'lS3_pT1_aS18_w700': '2.50 - 3.50',
            'lS3_pT1_aS19_w700': '2.50 - 3.50',
            'lS3_pT1_aS20_w700': '2.00 - 3.00',
            'lS3_pT1_aS21_w700': '2.00 - 3.00',
            'lS3_pT1_aS22_w700': '2.00 - 3.00',
            'lS3_pT1_aS23_w700': '2.00 - 3.00',
            'lS3_pT1_aS13_w800': '3.00 - 4.00',
            'lS3_pT1_aS14_w800': '3.00 - 4.00',
            'lS3_pT1_aS15_w800': '3.00 - 4.00',
            'lS3_pT1_aS16_w800': '3.00 - 4.00',
            'lS3_pT1_aS17_w800': '3.00 - 4.00',
            'lS3_pT1_aS18_w800': '3.00 - 4.00',
            'lS3_pT1_aS19_w800': '3.00 - 4.00',
            'lS3_pT1_aS20_w800': '3.00 - 4.00',
            'lS3_pT1_aS21_w800': '3.00 - 4.00',
            'lS3_pT1_aS22_w800': '3.00 - 4.00',
            'lS3_pT1_aS23_w800': '3.00 - 4.00',
            'lS3_pT1_aS13_w900': '3.00 - 4.00',
            'lS3_pT1_aS14_w900': '3.00 - 4.00',
            'lS3_pT1_aS15_w900': '3.00 - 4.00',
            'lS3_pT1_aS16_w900': '3.00 - 4.00',
            'lS3_pT1_aS17_w900': '3.00 - 4.00',
            'lS3_pT1_aS18_w900': '3.00 - 4.00',
            'lS3_pT1_aS19_w900': '3.00 - 4.00',
            'lS3_pT1_aS20_w900': '3.00 - 4.00',
            'lS3_pT1_aS21_w900': '3.00 - 4.00',
            'lS3_pT1_aS22_w900': '3.00 - 4.00',
            'lS3_pT1_aS23_w900': '3.00 - 4.00',
            'lS3_pT1_aS13_w1000': '3.00 - 4.00',
            'lS3_pT1_aS14_w1000': '3.00 - 4.00',
            'lS3_pT1_aS15_w1000': '3.00 - 4.00',
            'lS3_pT1_aS16_w1000': '3.00 - 4.00',
            'lS3_pT1_aS17_w1000': '3.00 - 4.00',
            'lS3_pT1_aS18_w1000': '3.00 - 4.00',
            'lS3_pT1_aS19_w1000': '3.00 - 4.00',
            'lS3_pT1_aS20_w1000': '3.00 - 4.00',
            'lS3_pT1_aS21_w1000': '3.00 - 4.00',
            'lS3_pT1_aS22_w1000': '3.00 - 4.00',
            'lS3_pT1_aS23_w1000': '3.00 - 4.00',
            'lS3_pT1_aS13_w1100': '4.00 - 5.00',
            'lS3_pT1_aS14_w1100': '4.00 - 5.00',
            'lS3_pT1_aS15_w1100': '4.00 - 5.00',
            'lS3_pT1_aS16_w1100': '4.00 - 5.00',
            'lS3_pT1_aS17_w1100': '4.00 - 5.00',
            'lS3_pT1_aS18_w1100': '4.00 - 5.00',
            'lS3_pT1_aS19_w1100': '4.00 - 5.00',
            'lS3_pT1_aS20_w1100': '3.00 - 4.00',
            'lS3_pT1_aS21_w1100': '3.00 - 4.00',
            'lS3_pT1_aS22_w1100': '3.00 - 4.00',
            'lS3_pT1_aS23_w1100': '3.00 - 4.00',
            'lS3_pT1_aS14_w1200': '4.00 - 5.00',
            'lS3_pT1_aS15_w1200': '4.00 - 5.00',
            'lS3_pT1_aS16_w1200': '4.00 - 5.00',
            'lS3_pT1_aS17_w1200': '4.00 - 5.00',
            'lS3_pT1_aS18_w1200': '4.00 - 5.00',
            'lS3_pT1_aS19_w1200': '4.00 - 5.00',
            'lS3_pT1_aS20_w1200': '3.00 - 4.00',
            'lS3_pT1_aS21_w1200': '3.00 - 4.00',
            'lS3_pT1_aS22_w1200': '3.00 - 4.00',
            'lS3_pT1_aS23_w1200': '3.00 - 4.00',
            'lS3_pT1_aS15_w1300': '4.00 - 5.00',
            'lS3_pT1_aS16_w1300': '4.00 - 5.00',
            'lS3_pT1_aS17_w1300': '4.00 - 5.00',
            'lS3_pT1_aS18_w1300': '4.00 - 5.00',
            'lS3_pT1_aS19_w1300': '4.00 - 5.00',
            'lS3_pT1_aS20_w1300': '4.00 - 5.00',
            'lS3_pT1_aS21_w1300': '3.00 - 4.00',
            'lS3_pT1_aS22_w1300': '3.00 - 4.00',
            'lS3_pT1_aS23_w1300': '3.00 - 4.00',
            'lS3_pT1_aS16_w1400': '4.00 - 5.00',
            'lS3_pT1_aS17_w1400': '4.00 - 5.00',
            'lS3_pT1_aS18_w1400': '4.00 - 5.00',
            'lS3_pT1_aS19_w1400': '4.00 - 5.00',
            'lS3_pT1_aS20_w1400': '4.00 - 5.00',
            'lS3_pT1_aS21_w1400': '4.00 - 5.00',
            'lS3_pT1_aS22_w1400': '3.00 - 4.00',
            'lS3_pT1_aS23_w1400': '3.00 - 4.00',
            'lS3_pT1_aS18_w1500': '4.00 - 5.00',
            'lS3_pT1_aS19_w1500': '4.00 - 5.00',
            'lS3_pT1_aS20_w1500': '4.00 - 5.00',
            'lS3_pT1_aS21_w1500': '4.00 - 5.00',
            'lS3_pT1_aS22_w1500': '3.00 - 4.00',
            'lS3_pT1_aS23_w1500': '3.00 - 4.00',
            'lS3_pT1_aS20_w1600': '4.00 - 5.00',
            'lS3_pT1_aS21_w1600': '4.00 - 5.00',
            'lS3_pT1_aS22_w1600': '3.00 - 4.00',
            'lS3_pT1_aS23_w1600': '3.00 - 4.00',
            'lS3_pT1_aS22_w1700': '3.00 - 4.00',
            'lS3_pT1_aS23_w1700': '3.00 - 4.00',
            'lS0_pT1_aSOM_w100': '0.25 - 0.5',
            'lS0_pT1_aSPM_w100': '0.5 - 0.75',
            'lS0_pT1_aSNMF3M_w100': '0.75 - 1.0',
            'lS0_pT1_aSNMS3M_w100': '0.5 - 0.75',
            'lS0_pT1_aSOM_w200': '0.25 - 0.5',
            'lS0_pT1_aSPM_w200': '0.5 - 0.75',
            'lS0_pT1_aSNMF3M_w200': '0.75 - 1.0',
            'lS0_pT1_aSNMS3M_w200': '0.5 - 0.75',
            'lS0_pT1_aSOM_w300': '0.5 - 0.75',
            'lS0_pT1_aSPM_w300': '0.75 - 1.25',
            'lS0_pT1_aSNMF3M_w300': '1.25 - 1.75',
            'lS0_pT1_aSNMS3M_w300': '0.75 - 1.25',
            'lS0_pT1_aSOM_w400': '0.5 - 1.0',
            'lS0_pT1_aSPM_w400': '1.0 - 1.5',
            'lS0_pT1_aSNMF3M_w400': '1.5 - 2.0',
            'lS0_pT1_aSNMS3M_w400': '1.0 - 1.5',
            'lS0_pT1_aSOM_w500': '0.5 - 1.0',
            'lS0_pT1_aSPM_w500': '1.0 - 1.5',
            'lS0_pT1_aSNMF3M_w500': '1.5 - 2.0',
            'lS0_pT1_aSNMS3M_w500': '1.0 - 1.5',
            'lS0_pT1_aSOM_w600': '0.75 - 1.75',
            'lS0_pT1_aSPM_w600': '2.0 - 3.0',
            'lS0_pT1_aSNMF3M_w600': '2.5 - 3.5',
            'lS0_pT1_aSNMS3M_w600': '2.0 - 3.0',
            'lS0_pT1_aSOM_w700': '0.75 - 1.75',
            'lS0_pT1_aSPM_w700': '2.0 - 3.0',
            'lS0_pT1_aSNMF3M_w700': '2.5 - 3.5',
            'lS0_pT1_aSNMS3M_w700': '2.0 - 3.0',
            'lS0_pT1_aSOM_w800': '0.75 - 1.75',
            'lS0_pT1_aSPM_w800': '2.0 - 3.0',
            'lS0_pT1_aSNMF3M_w800': '2.5 - 3.5',
            'lS0_pT1_aSNMS3M_w800': '2.0 - 3.0',
            'lS0_pT1_aSOM_w900': '1.0 - 2.0',
            'lS0_pT1_aSPM_w900': '2.5 - 3.5',
            'lS0_pT1_aSNMF3M_w900': '3.0 - 4.0',
            'lS0_pT1_aSNMS3M_w900': '2.5 - 3.5',
            'lS0_pT1_aSOM_w1000': '1.0 - 2.0',
            'lS0_pT1_aSPM_w1000': '2.5 - 3.5',
            'lS0_pT1_aSNMF3M_w1000': '3.0 - 4.0',
            'lS0_pT1_aSNMS3M_w1000': '2.5 - 3.5',
            'lS0_pT1_aSOM_w1100': '1.0 - 2.0',
            'lS0_pT1_aSPM_w1100': '2.5 - 3.5',
            'lS0_pT1_aSNMF3M_w1100': '3.0 - 4.0',
            'lS0_pT1_aSNMS3M_w1100': '2.5 - 3.5',
            'lS0_pT1_aSOM_w1200': '1.0 - 2.0',
            'lS0_pT1_aSPM_w1200': '2.5 - 3.5',
            'lS0_pT1_aSNMF3M_w1200': '3.0 - 4.0',
            'lS0_pT1_aSNMS3M_w1200': '2.5 - 3.5',
            'lS0_pT1_aSOM_w1300': '1.5 - 2.5',
            'lS0_pT1_aSPM_w1300': '3.0 - 4.0',
            'lS0_pT1_aSNMF3M_w1300': '4.0 - 5.0',
            'lS0_pT1_aSNMS3M_w1300': '3.0 - 4.0',
            'lS0_pT1_aSOM_w1400': '1.5 - 2.5',
            'lS0_pT1_aSPM_w1400': '3.0 - 4.0',
            'lS0_pT1_aSNMF3M_w1400': '4.0 - 5.0',
            'lS0_pT1_aSNMS3M_w1400': '3.0 - 4.0',
            'lS0_pT1_aSOM_w1500': '1.5 - 2.5',
            'lS0_pT1_aSPM_w1500': '3.0 - 4.0',
            'lS0_pT1_aSNMF3M_w1500': '4.0 - 5.0',
            'lS0_pT1_aSNMS3M_w1500': '3.0 - 4.0',
            'lS0_pT1_aSOM_w1600': '1.5 - 2.5',
            'lS0_pT1_aSPM_w1600': '3.0 - 4.0',
            'lS0_pT1_aSNMF3M_w1600': '4.0 - 5.0',
            'lS0_pT1_aSNMS3M_w1600': '3.0 - 4.0',
            'lS0_pT1_aSOM_w1700': '1.5 - 2.5',
            'lS0_pT1_aSPM_w1700': '3.0 - 4.0',
            'lS0_pT1_aSNMF3M_w1700': '4.0 - 5.0',
            'lS0_pT1_aSNMS3M_w1700': '3.0 - 4.0',
            'lS0_pT1_aSOM_w1800': '2.0 - 3.0',
            'lS0_pT1_aSPM_w1800': '3.5 - 4.5',
            'lS0_pT1_aSNMF3M_w1800': '4.5 - 5.5',
            'lS0_pT1_aSNMS3M_w1800': '3.5 - 4.5',
            'lS0_pT1_aSOM_w1900': '2.0 - 3.0',
            'lS0_pT1_aSPM_w1900': '3.5 - 4.5',
            'lS0_pT1_aSNMF3M_w1900': '4.5 - 5.5',
            'lS0_pT1_aSNMS3M_w1900': '3.5 - 4.5',
            'lS0_pT1_aSOM_w2000': '2.0 - 3.0',
            'lS0_pT1_aSPM_w2000': '3.5 - 4.5',
            'lS0_pT1_aSNMF3M_w2000': '4.5 - 5.5',
            'lS0_pT1_aSNMS3M_w2000': '3.5 - 4.5',
            'lS1_pT1_aSI_w100': '0.25 - 0.5',
            'lS1_pT1_aSL_w100': '0.5 - 0.75',
            'lS1_pT1_aSM_w100': '0.75 - 1.0',
            'lS1_pT1_aSI_w200': '0.25 - 0.5',
            'lS1_pT1_aSL_w200': '0.5 - 0.75',
            'lS1_pT1_aSM_w200': '0.75 - 1.0',
            'lS1_pT1_aSI_w300': '0.5 - 0.75',
            'lS1_pT1_aSL_w300': '0.75 - 1.25',
            'lS1_pT1_aSM_w300': '1.25 - 1.75',
            'lS1_pT1_aSI_w400': '0.5 - 1.0',
            'lS1_pT1_aSL_w400': '1.0 - 1.5',
            'lS1_pT1_aSM_w400': '1.5 - 2.0',
            'lS1_pT1_aSI_w500': '0.5 - 1.0',
            'lS1_pT1_aSL_w500': '1.0 - 1.5',
            'lS1_pT1_aSM_w500': '1.5 - 2.0',
            'lS1_pT1_aSI_w600': '0.75 - 1.75',
            'lS1_pT1_aSL_w600': '2.0 - 3.0',
            'lS1_pT1_aSM_w600': '2.5 - 3.5',
            'lS1_pT1_aSI_w700': '0.75 - 1.75',
            'lS1_pT1_aSL_w700': '2.0 - 3.0',
            'lS1_pT1_aSM_w700': '2.5 - 3.5',
            'lS1_pT1_aSI_w800': '0.75 - 1.75',
            'lS1_pT1_aSL_w800': '2.0 - 3.0',
            'lS1_pT1_aSM_w800': '2.5 - 3.5',
            'lS1_pT1_aSI_w900': '1.0 - 2.0',
            'lS1_pT1_aSL_w900': '2.5 - 3.5',
            'lS1_pT1_aSM_w900': '3.0 - 4.0',
            'lS1_pT1_aSI_w1000': '1.0 - 2.0',
            'lS1_pT1_aSL_w1000': '2.5 - 3.5',
            'lS1_pT1_aSM_w1000': '3.0 - 4.0',
            'lS1_pT1_aSI_w1100': '1.0 - 2.0',
            'lS1_pT1_aSL_w1100': '2.5 - 3.5',
            'lS1_pT1_aSM_w1100': '3.0 - 4.0',
            'lS1_pT1_aSI_w1200': '1.0 - 2.0',
            'lS1_pT1_aSL_w1200': '2.5 - 3.5',
            'lS1_pT1_aSM_w1200': '3.0 - 4.0',
            'lS1_pT1_aSI_w1300': '1.5 - 2.5',
            'lS1_pT1_aSL_w1300': '3.0 - 4.0',
            'lS1_pT1_aSM_w1300': '4.0 - 5.0',
            'lS1_pT1_aSI_w1400': '1.5 - 2.5',
            'lS1_pT1_aSL_w1400': '3.0 - 4.0',
            'lS1_pT1_aSM_w1400': '4.0 - 5.0',
            'lS1_pT1_aSI_w1500': '1.5 - 2.5',
            'lS1_pT1_aSL_w1500': '3.0 - 4.0',
            'lS1_pT1_aSM_w1500': '4.0 - 5.0',
            'lS1_pT1_aSI_w1600': '1.5 - 2.5',
            'lS1_pT1_aSL_w1600': '3.0 - 4.0',
            'lS1_pT1_aSM_w1600': '4.0 - 5.0',
            'lS1_pT1_aSI_w1700': '1.5 - 2.5',
            'lS1_pT1_aSL_w1700': '3.0 - 4.0',
            'lS1_pT1_aSM_w1700': '4.0 - 5.0',
            'lS1_pT1_aSI_w1800': '2.0 - 3.0',
            'lS1_pT1_aSL_w1800': '3.5 - 4.5',
            'lS1_pT1_aSM_w1800': '4.5 - 5.5',
            'lS1_pT1_aSI_w1900': '2.0 - 3.0',
            'lS1_pT1_aSL_w1900': '3.5 - 4.5',
            'lS1_pT1_aSM_w1900': '4.5 - 5.5',
            'lS1_pT1_aSI_w2000': '2.0 - 3.0',
            'lS1_pT1_aSL_w2000': '3.5 - 4.5',
            'lS1_pT1_aSM_w2000': '4.5 - 5.5',
            'lS2_pT0_aS3_w0': '1.00 - 3.00',
            'lS2_pT0_aS4_w0': '1.00 - 3.00',
            'lS2_pT0_aS5_w0': '1.00 - 3.00',
            'lS2_pT0_aS6_w0': '1.00 - 3.00',
            'lS2_pT0_aS7_w0': '1.00 - 3.00',
            'lS2_pT0_aS8_w0': '1.00 - 3.00',
            'lS2_pT0_aS9_w0': '1.00 - 3.00',
            'lS2_pT0_aS10_w0': '1.00 - 3.00',
            'lS2_pT0_aS11_w0': '1.00 - 3.00',
            'lS2_pT0_aS12_w0': '1.00 - 3.00',
            'lS2_pT0_aS3_w100': '1.00 - 3.00',
            'lS2_pT0_aS4_w100': '1.00 - 3.00',
            'lS2_pT0_aS5_w100': '1.00 - 3.00',
            'lS2_pT0_aS6_w100': '1.00 - 3.00',
            'lS2_pT0_aS7_w100': '1.00 - 3.00',
            'lS2_pT0_aS8_w100': '1.00 - 3.00',
            'lS2_pT0_aS9_w100': '1.00 - 3.00',
            'lS2_pT0_aS10_w100': '1.00 - 3.00',
            'lS2_pT0_aS11_w100': '1.00 - 3.00',
            'lS2_pT0_aS12_w100': '1.00 - 3.00',
            'lS2_pT0_aS3_w200': '2.00 - 4.00',
            'lS2_pT0_aS4_w200': '2.00 - 4.00',
            'lS2_pT0_aS5_w200': '2.00 - 4.00',
            'lS2_pT0_aS6_w200': '2.00 - 4.00',
            'lS2_pT0_aS7_w200': '2.00 - 4.00',
            'lS2_pT0_aS8_w200': '2.00 - 4.00',
            'lS2_pT0_aS9_w200': '2.00 - 4.00',
            'lS2_pT0_aS10_w200': '2.00 - 4.00',
            'lS2_pT0_aS11_w200': '2.00 - 4.00',
            'lS2_pT0_aS12_w200': '2.00 - 4.00',
            'lS2_pT0_aS3_w300': '3.00 - 5.00',
            'lS2_pT0_aS4_w300': '3.00 - 5.00',
            'lS2_pT0_aS5_w300': '3.00 - 5.00',
            'lS2_pT0_aS6_w300': '3.00 - 5.00',
            'lS2_pT0_aS7_w300': '3.00 - 5.00',
            'lS2_pT0_aS8_w300': '3.00 - 5.00',
            'lS2_pT0_aS9_w300': '3.00 - 5.00',
            'lS2_pT0_aS10_w300': '3.00 - 5.00',
            'lS2_pT0_aS11_w300': '3.00 - 5.00',
            'lS2_pT0_aS12_w300': '3.00 - 5.00',
            'lS2_pT0_aS3_w400': '4.00 - 6.00',
            'lS2_pT0_aS4_w400': '4.00 - 6.00',
            'lS2_pT0_aS5_w400': '4.00 - 6.00',
            'lS2_pT0_aS6_w400': '4.00 - 6.00',
            'lS2_pT0_aS7_w400': '4.00 - 6.00',
            'lS2_pT0_aS8_w400': '4.00 - 6.00',
            'lS2_pT0_aS9_w400': '4.00 - 6.00',
            'lS2_pT0_aS10_w400': '4.00 - 6.00',
            'lS2_pT0_aS11_w400': '4.00 - 6.00',
            'lS2_pT0_aS12_w400': '4.00 - 6.00',
            'lS2_pT0_aS3_w500': '5.00 - 7.00',
            'lS2_pT0_aS4_w500': '5.00 - 7.00',
            'lS2_pT0_aS5_w500': '5.00 - 7.00',
            'lS2_pT0_aS6_w500': '5.00 - 7.00',
            'lS2_pT0_aS7_w500': '5.00 - 7.00',
            'lS2_pT0_aS8_w500': '5.00 - 7.00',
            'lS2_pT0_aS9_w500': '5.00 - 7.00',
            'lS2_pT0_aS10_w500': '5.00 - 7.00',
            'lS2_pT0_aS11_w500': '5.00 - 7.00',
            'lS2_pT0_aS12_w500': '5.00 - 7.00',
            'lS2_pT0_aS3_w600': '6.00 - 8.00',
            'lS2_pT0_aS4_w600': '6.00 - 8.00',
            'lS2_pT0_aS5_w600': '6.00 - 8.00',
            'lS2_pT0_aS6_w600': '6.00 - 8.00',
            'lS2_pT0_aS7_w600': '6.00 - 8.00',
            'lS2_pT0_aS8_w600': '6.00 - 8.00',
            'lS2_pT0_aS9_w600': '6.00 - 8.00',
            'lS2_pT0_aS10_w600': '6.00 - 8.00',
            'lS2_pT0_aS11_w600': '6.00 - 8.00',
            'lS2_pT0_aS12_w600': '6.00 - 8.00',
            'lS2_pT0_aS4_w700': '6.00 - 8.00',
            'lS2_pT0_aS5_w700': '6.00 - 8.00',
            'lS2_pT0_aS6_w700': '6.00 - 8.00',
            'lS2_pT0_aS7_w700': '6.00 - 8.00',
            'lS2_pT0_aS8_w700': '6.00 - 8.00',
            'lS2_pT0_aS9_w700': '6.00 - 8.00',
            'lS2_pT0_aS10_w700': '6.00 - 8.00',
            'lS2_pT0_aS11_w700': '6.00 - 8.00',
            'lS2_pT0_aS12_w700': '6.00 - 8.00',
            'lS2_pT0_aS5_w800': '6.00 - 8.00',
            'lS2_pT0_aS6_w800': '6.00 - 8.00',
            'lS2_pT0_aS7_w800': '6.00 - 8.00',
            'lS2_pT0_aS8_w800': '6.00 - 8.00',
            'lS2_pT0_aS9_w800': '6.00 - 8.00',
            'lS2_pT0_aS10_w800': '6.00 - 8.00',
            'lS2_pT0_aS11_w800': '6.00 - 8.00',
            'lS2_pT0_aS12_w800': '6.00 - 8.00',
            'lS2_pT0_aS6_w900': '6.00 - 8.00',
            'lS2_pT0_aS7_w900': '6.00 - 8.00',
            'lS2_pT0_aS8_w900': '6.00 - 8.00',
            'lS2_pT0_aS9_w900': '6.00 - 8.00',
            'lS2_pT0_aS10_w900': '6.00 - 8.00',
            'lS2_pT0_aS11_w900': '6.00 - 8.00',
            'lS2_pT0_aS12_w900': '6.00 - 8.00',
            'lS2_pT0_aS7_w1000': '6.00 - 8.00',
            'lS2_pT0_aS8_w1000': '6.00 - 8.00',
            'lS2_pT0_aS9_w1000': '6.00 - 8.00',
            'lS2_pT0_aS10_w1000': '6.00 - 8.00',
            'lS2_pT0_aS11_w1000': '6.00 - 8.00',
            'lS2_pT0_aS12_w1000': '6.00 - 8.00',
            'lS3_pT0_aS13_w100': '2.00 - 4.00',
            'lS3_pT0_aS14_w100': '2.00 - 4.00',
            'lS3_pT0_aS15_w100': '2.00 - 4.00',
            'lS3_pT0_aS16_w100': '2.00 - 4.00',
            'lS3_pT0_aS17_w100': '2.00 - 4.00',
            'lS3_pT0_aS18_w100': '2.00 - 4.00',
            'lS3_pT0_aS19_w100': '2.00 - 4.00',
            'lS3_pT0_aS20_w100': '1.00 - 3.00',
            'lS3_pT0_aS21_w100': '1.00 - 3.00',
            'lS3_pT0_aS22_w100': '1.00 - 3.00',
            'lS3_pT0_aS23_w100': '1.00 - 3.00',
            'lS3_pT0_aS24_w100': '1.00 - 3.00',
            'lS3_pT0_aS13_w200': '2.00 - 4.00',
            'lS3_pT0_aS14_w200': '2.00 - 4.00',
            'lS3_pT0_aS15_w200': '2.00 - 4.00',
            'lS3_pT0_aS16_w200': '2.00 - 4.00',
            'lS3_pT0_aS17_w200': '2.00 - 4.00',
            'lS3_pT0_aS18_w200': '2.00 - 4.00',
            'lS3_pT0_aS19_w200': '2.00 - 4.00',
            'lS3_pT0_aS20_w200': '1.00 - 3.00',
            'lS3_pT0_aS21_w200': '1.00 - 3.00',
            'lS3_pT0_aS22_w200': '1.00 - 3.00',
            'lS3_pT0_aS23_w200': '1.00 - 3.00',
            'lS3_pT0_aS24_w200': '1.00 - 3.00',
            'lS3_pT0_aS13_w300': '3.00 - 5.00',
            'lS3_pT0_aS14_w300': '3.00 - 5.00',
            'lS3_pT0_aS15_w300': '3.00 - 5.00',
            'lS3_pT0_aS16_w300': '3.00 - 5.00',
            'lS3_pT0_aS17_w300': '3.00 - 5.00',
            'lS3_pT0_aS18_w300': '3.00 - 5.00',
            'lS3_pT0_aS19_w300': '3.00 - 5.00',
            'lS3_pT0_aS20_w300': '2.00 - 4.00',
            'lS3_pT0_aS21_w300': '2.00 - 4.00',
            'lS3_pT0_aS22_w300': '2.00 - 4.00',
            'lS3_pT0_aS23_w300': '2.00 - 4.00',
            'lS3_pT0_aS24_w300': '2.00 - 4.00',
            'lS3_pT0_aS13_w400': '4.00 - 6.00',
            'lS3_pT0_aS14_w400': '4.00 - 6.00',
            'lS3_pT0_aS15_w400': '4.00 - 6.00',
            'lS3_pT0_aS16_w400': '4.00 - 6.00',
            'lS3_pT0_aS17_w400': '4.00 - 6.00',
            'lS3_pT0_aS18_w400': '4.00 - 6.00',
            'lS3_pT0_aS19_w400': '4.00 - 6.00',
            'lS3_pT0_aS20_w400': '3.00 - 6.00',
            'lS3_pT0_aS21_w400': '3.00 - 6.00',
            'lS3_pT0_aS22_w400': '3.00 - 6.00',
            'lS3_pT0_aS23_w400': '3.00 - 6.00',
            'lS3_pT0_aS24_w400': '3.00 - 6.00',
            'lS3_pT0_aS13_w500': '5.00 - 7.00',
            'lS3_pT0_aS14_w500': '5.00 - 7.00',
            'lS3_pT0_aS15_w500': '5.00 - 7.00',
            'lS3_pT0_aS16_w500': '5.00 - 7.00',
            'lS3_pT0_aS17_w500': '5.00 - 7.00',
            'lS3_pT0_aS18_w500': '5.00 - 7.00',
            'lS3_pT0_aS19_w500': '5.00 - 7.00',
            'lS3_pT0_aS20_w500': '4.00 - 7.00',
            'lS3_pT0_aS21_w500': '4.00 - 7.00',
            'lS3_pT0_aS22_w500': '4.00 - 7.00',
            'lS3_pT0_aS23_w500': '4.00 - 7.00',
            'lS3_pT0_aS24_w500': '4.00 - 7.00',
            'lS3_pT0_aS13_w600': '6.00 - 8.00',
            'lS3_pT0_aS14_w600': '6.00 - 8.00',
            'lS3_pT0_aS15_w600': '6.00 - 8.00',
            'lS3_pT0_aS16_w600': '6.00 - 8.00',
            'lS3_pT0_aS17_w600': '6.00 - 8.00',
            'lS3_pT0_aS18_w600': '6.00 - 8.00',
            'lS3_pT0_aS19_w600': '6.00 - 8.00',
            'lS3_pT0_aS20_w600': '5.00 - 8.00',
            'lS3_pT0_aS21_w600': '5.00 - 8.00',
            'lS3_pT0_aS22_w600': '5.00 - 8.00',
            'lS3_pT0_aS23_w600': '5.00 - 8.00',
            'lS3_pT0_aS24_w600': '5.00 - 8.00',
            'lS3_pT0_aS13_w700': '6.00 - 8.00',
            'lS3_pT0_aS14_w700': '6.00 - 8.00',
            'lS3_pT0_aS15_w700': '6.00 - 8.00',
            'lS3_pT0_aS16_w700': '6.00 - 8.00',
            'lS3_pT0_aS17_w700': '6.00 - 8.00',
            'lS3_pT0_aS18_w700': '6.00 - 8.00',
            'lS3_pT0_aS19_w700': '6.00 - 8.00',
            'lS3_pT0_aS20_w700': '5.00 - 8.00',
            'lS3_pT0_aS21_w700': '5.00 - 8.00',
            'lS3_pT0_aS22_w700': '5.00 - 8.00',
            'lS3_pT0_aS23_w700': '5.00 - 8.00',
            'lS3_pT0_aS24_w700': '5.00 - 8.00',
            'lS3_pT0_aS13_w800': '6.00 - 8.00',
            'lS3_pT0_aS14_w800': '6.00 - 8.00',
            'lS3_pT0_aS15_w800': '6.00 - 8.00',
            'lS3_pT0_aS16_w800': '6.00 - 8.00',
            'lS3_pT0_aS17_w800': '6.00 - 8.00',
            'lS3_pT0_aS18_w800': '6.00 - 8.00',
            'lS3_pT0_aS19_w800': '6.00 - 8.00',
            'lS3_pT0_aS20_w800': '5.00 - 8.00',
            'lS3_pT0_aS21_w800': '5.00 - 8.00',
            'lS3_pT0_aS22_w800': '5.00 - 8.00',
            'lS3_pT0_aS23_w800': '5.00 - 8.00',
            'lS3_pT0_aS24_w800': '5.00 - 8.00',
            'lS3_pT0_aS13_w900': '6.00 - 8.00',
            'lS3_pT0_aS14_w900': '6.00 - 8.00',
            'lS3_pT0_aS15_w900': '6.00 - 8.00',
            'lS3_pT0_aS16_w900': '6.00 - 8.00',
            'lS3_pT0_aS17_w900': '6.00 - 8.00',
            'lS3_pT0_aS18_w900': '6.00 - 8.00',
            'lS3_pT0_aS19_w900': '6.00 - 8.00',
            'lS3_pT0_aS20_w900': '5.00 - 8.00',
            'lS3_pT0_aS21_w900': '5.00 - 8.00',
            'lS3_pT0_aS22_w900': '5.00 - 8.00',
            'lS3_pT0_aS23_w900': '5.00 - 8.00',
            'lS3_pT0_aS24_w900': '5.00 - 8.00',
            'lS3_pT0_aS13_w1000': '7.00 - 9.00',
            'lS3_pT0_aS14_w1000': '7.00 - 9.00',
            'lS3_pT0_aS15_w1000': '7.00 - 9.00',
            'lS3_pT0_aS16_w1000': '7.00 - 9.00',
            'lS3_pT0_aS17_w1000': '7.00 - 9.00',
            'lS3_pT0_aS18_w1000': '7.00 - 9.00',
            'lS3_pT0_aS19_w1000': '7.00 - 9.00',
            'lS3_pT0_aS20_w1000': '6.00 - 9.00',
            'lS3_pT0_aS21_w1000': '6.00 - 9.00',
            'lS3_pT0_aS22_w1000': '6.00 - 9.00',
            'lS3_pT0_aS23_w1000': '6.00 - 9.00',
            'lS3_pT0_aS24_w1000': '6.00 - 9.00',
            'lS3_pT0_aS13_w1100': '7.00 - 9.00',
            'lS3_pT0_aS14_w1100': '7.00 - 9.00',
            'lS3_pT0_aS15_w1100': '7.00 - 9.00',
            'lS3_pT0_aS16_w1100': '7.00 - 9.00',
            'lS3_pT0_aS17_w1100': '7.00 - 9.00',
            'lS3_pT0_aS18_w1100': '7.00 - 9.00',
            'lS3_pT0_aS19_w1100': '7.00 - 9.00',
            'lS3_pT0_aS20_w1100': '6.00 - 9.00',
            'lS3_pT0_aS21_w1100': '6.00 - 9.00',
            'lS3_pT0_aS22_w1100': '6.00 - 9.00',
            'lS3_pT0_aS23_w1100': '6.00 - 9.00',
            'lS3_pT0_aS24_w1100': '6.00 - 9.00',
            'lS3_pT0_aS14_w1200': '7.00 - 9.00',
            'lS3_pT0_aS15_w1200': '7.00 - 9.00',
            'lS3_pT0_aS16_w1200': '7.00 - 9.00',
            'lS3_pT0_aS17_w1200': '7.00 - 9.00',
            'lS3_pT0_aS18_w1200': '7.00 - 9.00',
            'lS3_pT0_aS19_w1200': '7.00 - 9.00',
            'lS3_pT0_aS20_w1200': '6.00 - 9.00',
            'lS3_pT0_aS21_w1200': '6.00 - 9.00',
            'lS3_pT0_aS22_w1200': '6.00 - 9.00',
            'lS3_pT0_aS23_w1200': '6.00 - 9.00',
            'lS3_pT0_aS24_w1200': '6.00 - 9.00',
            'lS3_pT0_aS15_w1300': '8.00 - 10.00',
            'lS3_pT0_aS16_w1300': '8.00 - 10.00',
            'lS3_pT0_aS17_w1300': '8.00 - 10.00',
            'lS3_pT0_aS18_w1300': '8.00 - 10.00',
            'lS3_pT0_aS19_w1300': '8.00 - 10.00',
            'lS3_pT0_aS20_w1300': '7.00 - 10.00',
            'lS3_pT0_aS21_w1300': '7.00 - 10.00',
            'lS3_pT0_aS22_w1300': '7.00 - 10.00',
            'lS3_pT0_aS23_w1300': '7.00 - 10.00',
            'lS3_pT0_aS24_w1300': '7.00 - 10.00',
            'lS3_pT0_aS16_w1400': '8.00 - 10.00',
            'lS3_pT0_aS17_w1400': '8.00 - 10.00',
            'lS3_pT0_aS18_w1400': '8.00 - 10.00',
            'lS3_pT0_aS19_w1400': '8.00 - 10.00',
            'lS3_pT0_aS20_w1400': '7.00 - 10.00',
            'lS3_pT0_aS21_w1400': '7.00 - 10.00',
            'lS3_pT0_aS22_w1400': '7.00 - 10.00',
            'lS3_pT0_aS23_w1400': '7.00 - 10.00',
            'lS3_pT0_aS24_w1400': '7.00 - 10.00',
            'lS3_pT0_aS18_w1500': '8.00 - 10.00',
            'lS3_pT0_aS19_w1500': '8.00 - 10.00',
            'lS3_pT0_aS20_w1500': '7.00 - 10.00',
            'lS3_pT0_aS21_w1500': '7.00 - 10.00',
            'lS3_pT0_aS22_w1500': '7.00 - 10.00',
            'lS3_pT0_aS23_w1500': '7.00 - 10.00',
            'lS3_pT0_aS24_w1500': '7.00 - 10.00',
            'lS3_pT0_aS20_w1600': '7.00 - 10.00',
            'lS3_pT0_aS21_w1600': '7.00 - 10.00',
            'lS3_pT0_aS22_w1600': '7.00 - 10.00',
            'lS3_pT0_aS23_w1600': '7.00 - 10.00',
            'lS3_pT0_aS24_w1600': '7.00 - 10.00',
            'lS3_pT0_aS22_w1700': '7.00 - 10.00',
            'lS3_pT0_aS23_w1700': '7.00 - 10.00',
            'lS3_pT0_aS24_w1700': '7.00 - 10.00',
            'lS3_pT0_aS24_w1800': '8.00 - 12.00',
            'lS3_pT0_aS24_w1900': '8.00 - 12.00',
            'lS3_pT0_aS24_w2000': '8.00 - 12.00',
            'lS0_pT0_aSOM_w100': '1.00 - 3.00',
            'lS0_pT0_aSPM_w100': '1.00 - 3.00',
            'lS0_pT0_aSNMF3M_w100': '1.25 - 3.25',
            'lS0_pT0_aSNMS3M_w100': '1.00 - 3.00',
            'lS0_pT0_aSOM_w200': '1.00 - 3.00',
            'lS0_pT0_aSPM_w200': '1.00 - 3.00',
            'lS0_pT0_aSNMF3M_w200': '1.25 - 3.25',
            'lS0_pT0_aSNMS3M_w200': '1.00 - 3.00',
            'lS0_pT0_aSOM_w300': '1.50 - 3.50',
            'lS0_pT0_aSPM_w300': '1.50 - 3.50',
            'lS0_pT0_aSNMF3M_w300': '2.00 - 4.00',
            'lS0_pT0_aSNMS3M_w300': '1.50 - 3.50',
            'lS0_pT0_aSOM_w400': '2.00 - 4.00',
            'lS0_pT0_aSPM_w400': '2.00 - 4.00',
            'lS0_pT0_aSNMF3M_w400': '2.50 - 4.50',
            'lS0_pT0_aSNMS3M_w400': '2.00 - 4.00',
            'lS0_pT0_aSOM_w500': '2.00 - 4.00',
            'lS0_pT0_aSPM_w500': '2.00 - 4.00',
            'lS0_pT0_aSNMF3M_w500': '2.50 - 4.51',
            'lS0_pT0_aSNMS3M_w500': '2.00 - 4.00',
            'lS0_pT0_aSOM_w600': '2.50 - 5.50',
            'lS0_pT0_aSPM_w600': '2.50 - 5.50',
            'lS0_pT0_aSNMF3M_w600': '3.50 - 6.50',
            'lS0_pT0_aSNMS3M_w600': '2.50 - 5.50',
            'lS0_pT0_aSOM_w700': '3.00 - 6.00',
            'lS0_pT0_aSPM_w700': '3.00 - 6.00',
            'lS0_pT0_aSNMF3M_w700': '4.00 - 7.00',
            'lS0_pT0_aSNMS3M_w700': '3.00 - 6.00',
            'lS0_pT0_aSOM_w800': '3.50 - 6.50',
            'lS0_pT0_aSPM_w800': '3.50 - 6.50',
            'lS0_pT0_aSNMF3M_w800': '4.50 - 7.50',
            'lS0_pT0_aSNMS3M_w800': '3.50 - 6.50',
            'lS0_pT0_aSOM_w900': '4.00 - 8.00',
            'lS0_pT0_aSPM_w900': '4.00 - 8.00',
            'lS0_pT0_aSNMF3M_w900': '5.00 - 10.00',
            'lS0_pT0_aSNMS3M_w900': '4.00 - 8.00',
            'lS0_pT0_aSOM_w1000': '4.00 - 8.00',
            'lS0_pT0_aSPM_w1000': '4.00 - 8.00',
            'lS0_pT0_aSNMF3M_w1000': '5.00 - 10.00',
            'lS0_pT0_aSNMS3M_w1000': '4.00 - 8.00',
            'lS0_pT0_aSOM_w1100': '5.00 - 10.00',
            'lS0_pT0_aSPM_w1100': '5.00 - 10.00',
            'lS0_pT0_aSNMF3M_w1100': '6.00 - 12.00',
            'lS0_pT0_aSNMS3M_w1100': '5.00 - 10.00',
            'lS0_pT0_aSOM_w1200': '5.00 - 10.00',
            'lS0_pT0_aSPM_w1200': '5.00 - 10.00',
            'lS0_pT0_aSNMF3M_w1200': '6.00 - 12.00',
            'lS0_pT0_aSNMS3M_w1200': '5.00 - 10.00',
            'lS0_pT0_aSOM_w1300': '6.00 - 12.00',
            'lS0_pT0_aSPM_w1300': '6.00 - 12.00',
            'lS0_pT0_aSNMF3M_w1300': '7.00 - 14.00',
            'lS0_pT0_aSNMS3M_w1300': '6.00 - 12.00',
            'lS0_pT0_aSOM_w1400': '6.00 - 12.00',
            'lS0_pT0_aSPM_w1400': '6.00 - 12.00',
            'lS0_pT0_aSNMF3M_w1400': '7.00 - 14.00',
            'lS0_pT0_aSNMS3M_w1400': '6.00 - 12.00',
            'lS0_pT0_aSOM_w1500': '6.00 - 12.00',
            'lS0_pT0_aSPM_w1500': '6.00 - 12.00',
            'lS0_pT0_aSNMF3M_w1500': '7.00 - 14.00',
            'lS0_pT0_aSNMS3M_w1500': '6.00 - 12.00',
            'lS0_pT0_aSOM_w1600': '6.00 - 12.00',
            'lS0_pT0_aSPM_w1600': '6.00 - 12.00',
            'lS0_pT0_aSNMF3M_w1600': '7.00 - 14.00',
            'lS0_pT0_aSNMS3M_w1600': '6.00 - 12.00',
            'lS0_pT0_aSOM_w1700': '7.00 - 14.00',
            'lS0_pT0_aSPM_w1700': '7.00 - 14.00',
            'lS0_pT0_aSNMF3M_w1700': '8.00 - 16.00',
            'lS0_pT0_aSNMS3M_w1700': '7.00 - 14.00',
            'lS0_pT0_aSOM_w1800': '7.00 - 14.00',
            'lS0_pT0_aSPM_w1800': '7.00 - 14.00',
            'lS0_pT0_aSNMF3M_w1800': '8.00 - 16.00',
            'lS0_pT0_aSNMS3M_w1800': '7.00 - 14.00',
            'lS0_pT0_aSOM_w1900': '7.00 - 14.00',
            'lS0_pT0_aSPM_w1900': '7.00 - 14.00',
            'lS0_pT0_aSNMF3M_w1900': '8.00 - 16.00',
            'lS0_pT0_aSNMS3M_w1900': '7.00 - 14.00',
            'lS0_pT0_aSOM_w2000': '7.00 - 14.00',
            'lS0_pT0_aSPM_w2000': '7.00 - 14.00',
            'lS0_pT0_aSNMF3M_w2000': '8.00 - 16.00',
            'lS0_pT0_aSNMS3M_w2000': '7.00 - 14.00',
            'lS1_pT0_aSI_w100': '1.00 - 3.00',
            'lS1_pT0_aSL_w100': '1.25 - 3.25',
            'lS1_pT0_aSM_w100': '1.50 - 3.50',
            'lS1_pT0_aSH_w100': '1.75 - 3.75',
            'lS1_pT0_aSI_w200': '1.00 - 3.00',
            'lS1_pT0_aSL_w200': '1.25 - 3.25',
            'lS1_pT0_aSM_w200': '1.50 - 3.50',
            'lS1_pT0_aSH_w200': '1.75 - 3.75',
            'lS1_pT0_aSI_w300': '1.50 - 3.50',
            'lS1_pT0_aSL_w300': '2.00 - 4.00',
            'lS1_pT0_aSM_w300': '2.50 - 4.50',
            'lS1_pT0_aSH_w300': '3.00 - 5.00',
            'lS1_pT0_aSI_w400': '2.00 - 4.00',
            'lS1_pT0_aSL_w400': '2.50 - 4.50',
            'lS1_pT0_aSM_w400': '3.00 - 5.00',
            'lS1_pT0_aSH_w400': '3.50 - 5.50',
            'lS1_pT0_aSI_w500': '2.00 - 4.00',
            'lS1_pT0_aSL_w500': '2.50 - 4.50',
            'lS1_pT0_aSM_w500': '3.00 - 5.00',
            'lS1_pT0_aSH_w500': '3.50 - 5.50',
            'lS1_pT0_aSI_w600': '2.50 - 5.50',
            'lS1_pT0_aSL_w600': '3.50 - 6.50',
            'lS1_pT0_aSM_w600': '4.50 - 7.50',
            'lS1_pT0_aSH_w600': '5.50 - 8.50',
            'lS1_pT0_aSI_w700': '3.00 - 6.00',
            'lS1_pT0_aSL_w700': '4.00 - 7.00',
            'lS1_pT0_aSM_w700': '5.00 - 8.00',
            'lS1_pT0_aSH_w700': '6.00 - 9.00',
            'lS1_pT0_aSI_w800': '3.50 - 6.50',
            'lS1_pT0_aSL_w800': '4.50 - 7.50',
            'lS1_pT0_aSM_w800': '5.50 - 8.50',
            'lS1_pT0_aSH_w800': '6.50 - 9.50',
            'lS1_pT0_aSI_w900': '4.00 - 8.00',
            'lS1_pT0_aSL_w900': '5.00 - 10.00',
            'lS1_pT0_aSM_w900': '6.00 - 12.00',
            'lS1_pT0_aSH_w900': '7.00 - 14.00',
            'lS1_pT0_aSI_w1000': '4.00 - 8.00',
            'lS1_pT0_aSL_w1000': '5.00 - 10.00',
            'lS1_pT0_aSM_w1000': '6.00 - 12.00',
            'lS1_pT0_aSH_w1000': '7.00 - 14.00',
            'lS1_pT0_aSI_w1100': '5.00 - 10.00',
            'lS1_pT0_aSL_w1100': '6.00 - 12.00',
            'lS1_pT0_aSM_w1100': '7.00 - 14.00',
            'lS1_pT0_aSH_w1100': '8.00 - 16.00',
            'lS1_pT0_aSI_w1200': '5.00 - 10.00',
            'lS1_pT0_aSL_w1200': '6.00 - 12.00',
            'lS1_pT0_aSM_w1200': '7.00 - 14.00',
            'lS1_pT0_aSH_w1200': '8.00 - 16.00',
            'lS1_pT0_aSI_w1300': '6.00 - 12.00',
            'lS1_pT0_aSL_w1300': '7.00 - 14.00',
            'lS1_pT0_aSM_w1300': '8.00 - 16.00',
            'lS1_pT0_aSH_w1300': '9.00 - 18.00',
            'lS1_pT0_aSI_w1400': '6.00 - 12.00',
            'lS1_pT0_aSL_w1400': '7.00 - 14.00',
            'lS1_pT0_aSM_w1400': '8.00 - 16.00',
            'lS1_pT0_aSH_w1400': '9.00 - 18.00',
            'lS1_pT0_aSI_w1500': '6.00 - 12.00',
            'lS1_pT0_aSL_w1500': '7.00 - 14.00',
            'lS1_pT0_aSM_w1500': '8.00 - 16.00',
            'lS1_pT0_aSH_w1500': '9.00 - 18.00',
            'lS1_pT0_aSI_w1600': '6.00 - 12.00',
            'lS1_pT0_aSL_w1600': '7.00 - 14.00',
            'lS1_pT0_aSM_w1600': '8.00 - 16.00',
            'lS1_pT0_aSH_w1600': '9.00 - 18.00',
            'lS1_pT0_aSI_w1700': '7.00 - 14.00',
            'lS1_pT0_aSL_w1700': '8.00 - 16.00',
            'lS1_pT0_aSM_w1700': '9.00 - 18.00',
            'lS1_pT0_aSH_w1700': '10.00 - 20.00',
            'lS1_pT0_aSI_w1800': '7.00 - 14.00',
            'lS1_pT0_aSL_w1800': '8.00 - 16.00',
            'lS1_pT0_aSM_w1800': '9.00 - 18.00',
            'lS1_pT0_aSH_w1800': '10.00 - 20.00',
            'lS1_pT0_aSI_w1900': '7.00 - 14.00',
            'lS1_pT0_aSL_w1900': '8.00 - 16.00',
            'lS1_pT0_aSM_w1900': '9.00 - 18.00',
            'lS1_pT0_aSH_w1900': '10.00 - 20.00',
            'lS1_pT0_aSI_w2000': '7.00 - 14.00',
            'lS1_pT0_aSL_w2000': '8.00 - 16.00',
            'lS1_pT0_aSM_w2000': '9.00 - 18.00',
            'lS1_pT0_aSH_w2000': '10.00 - 20.00'
        }

        J(function() {
            initLifeStageOptions();
            initProductTypeOptions();

            J('#form-daily-feed').submit(function(e) {
                e.preventDefault();
            });

            J('#select-life-stage').change(function() {
                clearAgeStatusAndWeight();

                var productTypeElement = J('#select-product-type');
                if (this.value !== '' && productTypeElement.val() !== '') {
                    updateAgeStatusOptions(this.value, productTypeElement.val());
                }
            });

            J('#select-product-type').change(function() {
                clearAgeStatusAndWeight();

                var lifeStageElement = J('#select-life-stage');
                if (this.value !== '' && lifeStageElement.val() !== '') {
                    updateAgeStatusOptions(lifeStageElement.val(), this.value);
                }
            });

            J('#select-age-status').change(function() {
                var lifeStageElement = J('#select-life-stage');
                var productTypeElement = J('#select-product-type');

                if(this.value !== '' && lifeStageElement.val() !== '' && productTypeElement !== '') {
                    updateWeightOptions(this.value);
                }
            });

            J('#select-weight').change(function() {
                if (this.value !== '') {
                    updateResults(this.value);
                }
            })
        });

        function initLifeStageOptions() {
            var lifeStageOptionsHtml = '<option/>';
            J.each(lifeStageOptions, function (k, v) {
                lifeStageOptionsHtml += '<option value="' + k + '">' + v + '</option>';
            });

            J('#select-life-stage').html(lifeStageOptionsHtml);
        }

        function initProductTypeOptions() {
            var productTypeOptionsHtml = '<option/>';
            J.each(productTypeOptions, function (k, v) {
                productTypeOptionsHtml += '<option value="' + k + '">' + v + '</option>';
            });

            J('#select-product-type').html(productTypeOptionsHtml);
        }

        function updateAgeStatusOptions(lifeStageKey, productTypeKey) {
            var ageStatusElement = J('#select-age-status');
            ageStatusElement.empty();

            var ageStatusKey = lifeStageKey + '_' + productTypeKey
            var ageStatusOptionValue = ageStatusKey + '_aS';

            var ageStatusOptionsHtml = '<option/>';
            J.each(ageStatusOptions[ageStatusKey], function(i, v) {
                var ageStatusOptionLabel = J.isNumeric(v) ? (v + " month") : v;
                ageStatusOptionsHtml += '<option value="' + ageStatusOptionValue + (J.isNumeric(v) ? v : buildAgeStatusKey(v)) + '">' + ageStatusOptionLabel + '</option>';
            });

            ageStatusElement.html(ageStatusOptionsHtml);
        }

        function updateWeightOptions(ageStatusKey) {
            var weightElement = J('#select-weight');
            weightElement.empty();

            var weightOptionValue = ageStatusKey + '_w';

            var weightOptionsHtml = '<option/>';
            J.each(weightOptions[ageStatusKey], function(i, v) {
                weightOptionsHtml += '<option value="' + weightOptionValue + buildWeightKey(v) + '">' + v + '</option>';
            });

            weightElement.html(weightOptionsHtml);
        }

        function updateResults(weightKey) {
            var lbsLabel = ' lbs.'
            J('#result-daily-feed').html(results[weightKey] + lbsLabel);
        }

        function clearAgeStatusAndWeight() {
            J('#select-age-status').empty();
            J('#select-weight').empty();
        }

        function buildAgeStatusKey(value) {
            var key = '';
            var array = value.split(' ');

            J.each(array, function(i, v) {
                key += v.charAt(0)
            });

            return key;
        }

        function buildWeightKey(value) {
            var key = '';

            if (value.charAt(0) === '<') {
                key += '0';
            } else {
                var array = value.split(' ');
                key += array[0];
            }

            return key;
        }